module.exports = __webpack_public_path__ + "static/media/hometown-3-shot-2.cdaedbb8.webp";